import { useState } from "react";
import { Card, CardContent } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { LockKeyhole } from "lucide-react";

export default function () {

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const trimmedEmail = email.trim();

    const handleForgot = async (e) => {
        e.preventDefault();

        if (!trimmedEmail) {
            toast.error('Please enter Email');
            return;
        }
        setError("");

        try {
            const data = { email };
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/users/forgot-password-user`, data
                // ${process.env.NEXT_PUBLIC_API_BASE_URL}//, data
            );
            toast.success('Email Sent!')
            setTimeout(() => {
                window.location.href = "/home";
            }, 3000);
        } catch (error) {
            console.log("message", error);
            if (error.response) {
                toast.error(error.response.data.message);
            }
            else {
                toast.error("Unable to reach the server");
            }
        }
    };


    return (
        <div
            className="h-screen bg-cover bg-center flex flex-col justify-center items-center text-white text-center px-6"
            style={{ backgroundImage: "url('/images/bg.jpg')" }}>
            <Card className="w-full max-w-[400px]" sx={{ borderRadius: '15px', paddingTop: '10px' }}>
                <div className="flex justify-center">
                    <img src="/images/logo.png" alt="logo" className="max-w-[100px]" />
                </div>
                <CardContent sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                    <h2 className="text-xl font-semibold text-center text-[#000]">Forgot Password</h2>
                    <p className="mt-4 text-center text-sm">Please enter your Email ID to retrieve your password.</p>
                    <form onSubmit={handleForgot} className="space-y-4 pt-5 pb-0 px-[10px]">
                        <div class="relative">
                            <input type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder=""
                                id="float_email" className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none  dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" />
                            <label for="float_email" className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2
      peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600
      peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2
      peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75
      peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Email</label>
                        </div>


                        <button
                            type="submit"
                            className="w-[150px] flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-[6px] px-6 rounded-[50px] text-base border-2 border-blue-500 justify-center m-auto"
                        >
                            <LockKeyhole size={25} />
                            Recover
                        </button>

                    </form>

                </CardContent>
            </Card>
            <ToastContainer />

        </div>
    );
}